import './i18n';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from 'Store';

import { App } from './App';
import { Initializer } from './Initializer';

const AppWithProviders = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <Initializer>
          <App />
        </Initializer>
      </PersistGate>
    </Provider>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<AppWithProviders />);
